
declare global {
  interface String {
    capitalize(): string;(length: number): string;
  }
}
Object.defineProperty(String.prototype, "capitalize", {
  value: function() {
    if (this.length === 0) {
      return this;
    }
    return this.charAt(0).toUpperCase() + this.slice(1);
  },
  writable: true,
  configurable: true,
});
export const camelCaseToSnakeCase = (str) => {
  return str.replace(/([a-zA-Z])(?=[A-Z])/g, "$1_").toLowerCase();
};
export const snakeCaseToCamelCase = (str) => {
  return str.replace(/_([a-z])/g, function(g) {
    return g[1].toUpperCase();
  });
};
